import React from "react";

export default function PreconChecklistIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
      <rect
        x="1"
        y="1.5"
        width="3"
        height="3"
        rx="0.6"
        stroke="currentColor"
        strokeWidth="1.1"
      />
      <path
        d="M1.7 3 L2.5 3.8 L3.4 2.1"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="6"
        y1="3"
        x2="13"
        y2="3"
        stroke="currentColor"
        strokeWidth="1.1"
      />

      <rect
        x="1"
        y="5.5"
        width="3"
        height="3"
        rx="0.6"
        stroke="currentColor"
        strokeWidth="1.1"
      />
      <line
        x1="6"
        y1="7"
        x2="13"
        y2="7"
        stroke="currentColor"
        strokeWidth="1.1"
      />

      <rect
        x="1"
        y="9.5"
        width="3"
        height="3"
        rx="0.6"
        stroke="currentColor"
        strokeWidth="1.1"
      />
      <path
        d="M1.7 11 L2.5 11.8 L3.4 10.1"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="6"
        y1="11"
        x2="13"
        y2="11"
        stroke="currentColor"
        strokeWidth="1.1"
      />
    </svg>
  );
}
